const VALIDATION_STATES = {
    ERROR: 'error',
};
export default VALIDATION_STATES;
